import React, { ReactNode } from 'react';
import '../styles/dd-menu-wrapper.css';

interface DDMenuWrapperProps {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * DDMenuWrapper - A component that creates an isolated styling context for DDMenu components
 * 
 * This wrapper creates a boundary that prevents external styles from affecting the DDMenu
 * component's appearance and positioning. Use this wrapper when integrating DDMenu in
 * environments with conflicting styles (like complex navbars).
 * 
 * @example
 * ```tsx
 * <DDMenuWrapper>
 *   <DDMenu items={items} />
 * </DDMenuWrapper>
 * ```
 */
const DDMenuWrapper: React.FC<DDMenuWrapperProps> = ({ 
  children, 
  className = '',
  style = {}
}) => {
  return (
    <div 
      className={`dd-menu-wrapper ${className}`} 
      style={style}
    >
      {children}
    </div>
  );
};

export default DDMenuWrapper;
